import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Features } from '../components/Features';
import { DashboardPreview } from '../components/DashboardPreview';
import { UseCases } from '../components/UseCases';
import { Testimonials } from '../components/Testimonials';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { About } from '../components/About';
import { CTA } from '../components/CTA';
import { Footer } from '../components/Footer';
import { scrollToSection } from '../utils/config';

export const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Se houver hash na URL, fazer scroll para a seção após um pequeno delay
    // para garantir que a página foi renderizada
    if (location.hash) {
      const sectionId = location.hash.substring(1); // Remove o #
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    } else {
      // Se não houver hash, fazer scroll para o topo
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="landing-page">
      <Header />
      <main>
        <Hero />
        <Stats />
        <Features />
        <DashboardPreview />
        <UseCases />
        <Testimonials />
        <Pricing />
        <FAQ />
        <About />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

